/* THÀNH PHẦN DÙNG CHUNG: nút kênh, tên khách */
import React from 'react';
import { Button } from 'antd';
import { Phone } from 'lucide-react';
import { PROFILES } from './Data';
import { useS } from './Store';
import { Link, Lock } from './UI';
import type { Customer } from './Types';

export const NameLink: React.FC<{ c: Customer }> = ({ c }) => {
  const S = useS();
  if (!PROFILES[c.ma]) {
    return <span><b>{c.ma}</b> · {c.ten} <span className="rounded bg-slate-200 px-1 text-[11px] dark:bg-slate-700">CSKH</span></span>;
  }
  return <Link onClick={() => S.openTab(c.ma)}><b>{c.ma}</b> · {c.ten}</Link>;
};
export const SdtLink: React.FC<{ c: Customer }> = ({ c }) => {
  const S = useS();
  return PROFILES[c.ma] ? <Link onClick={() => S.openTab(c.ma)}>{c.sdt}</Link> : <span>{c.sdt}</span>;
};

/** Nút chính đổi theo “Kênh khách muốn”; WhatsApp chỉ hiện với số nước ngoài */
export const ChanButtons: React.FC<{ c: Customer; big?: boolean }> = ({ c, big }) => {
  const S = useS();
  if (c.phong === 'CSKH') return null;
  const k = c.kenh || 'Gọi';
  const prim = k === 'Chỉ nhắn tin' ? 'Zalo' : k !== 'Gọi' ? k : 'Gọi';
  const other = !!S.call && S.call.ma !== c.ma;
  const noCall = S.noCall(c.ma);
  const callDis = k === 'Chỉ nhắn tin' || noCall || (!!big && other);
  const call = (
    <Button
      key="g"
      size="small"
      type={prim === 'Gọi' ? 'primary' : 'default'}
      disabled={callDis}
      icon={<Phone size={13} />}
      onClick={() => S.startCall(c.ma)}
      className='dark:text-white'
    >
      {big ? 'Gọi khách này' : 'Gọi'}
    </Button>
  );
  const z = <Button key="z" size="small" type={prim === 'Zalo' ? 'primary' : 'default'} onClick={() => S.openMsg(c.ma, 'Zalo')}>Zalo</Button>;
  const w = c.nn ? <Button key="w" size="small" type={prim === 'WhatsApp' ? 'primary' : 'default'} onClick={() => S.openMsg(c.ma, 'WhatsApp')}>WhatsApp</Button> : null;
  const order = prim === 'Zalo' ? [z, call, w] : prim === 'WhatsApp' ? [w, call, z] : [call, z, w];
  return (
    <div>
      <div className="flex flex-wrap gap-1">{order}</div>
      {k === 'Chỉ nhắn tin' && <Lock navy>Chỉ nhắn Zalo</Lock>}
      {noCall && k !== 'Chỉ nhắn tin' && <Lock>Cờ Không gọi (R19) — chỉ nhắn Zalo</Lock>}
      {big && other && <Lock>Đang có cuộc gọi khác — lưu mã kết quả trước (R01)</Lock>}
    </div>
  );
};